import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useImpactClaims } from 'hooks';
import { CheckList, DocumentContainer, SdgPills, SubTitle, } from 'components/Shared';
import { ImpactClaimDefinition } from 'components/Shared/ImpactClaims';
import OpenDetailsButton from 'components/Shared/OpenDetailsButton';
import { animated, useSpring } from 'react-spring';
const SectionContainer = styled.div `
  margin: 30px 0;
`;
const DetailsContainer = styled(animated.div) `
  position: relative;
  overflow: hidden;
`;
const SelectedImpactClaimBlock = ({ goToDocuments, impactClaim, definitionTitle, }) => {
    const { selectedClaim } = useImpactClaims() || {};
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const toggle = () => setOpen((current) => !current);
    // This component is used for the global impact claims and for the impact claims on partner level.
    // The global impact claims use the impactClaim context.
    // For the supplements, the impact claim is passed to the component.
    const claim = impactClaim ? impactClaim : selectedClaim;
    const stylesOpen = useSpring({
        maxHeight: open ? 2000 : 0,
    });
    return (React.createElement(Fragment, null,
        React.createElement(ImpactClaimDefinition, { impactClaim: claim, title: definitionTitle }),
        claim && (React.createElement(Fragment, null,
            React.createElement(SectionContainer, null,
                React.createElement(DocumentContainer, { multi: true, onDocumentClick: () => claim.attachmentCount > 0 ? goToDocuments() : null },
                    React.createElement(Fragment, null, t('impact-claims.proof-documents', {
                        count: claim.attachmentCount,
                    })))),
            React.createElement(OpenDetailsButton, { toggle: toggle, open: open, margin: "10px 3px 5px" }),
            React.createElement(DetailsContainer, { style: stylesOpen },
                React.createElement("div", null,
                    (claim === null || claim === void 0 ? void 0 : claim.impactCatalogItem.sustainableDevGoals.length) !== 0 && (React.createElement(SectionContainer, null,
                        React.createElement(SubTitle, null, t('impact-claims.connected-global-goals')),
                        React.createElement(SdgPills, { sdgs: (claim === null || claim === void 0 ? void 0 : claim.impactCatalogItem.sustainableDevGoals) || [] }))),
                    React.createElement(SectionContainer, null,
                        React.createElement(SubTitle, { tooltip: t('impact-claims.criteria-info', {
                                impactTitle: claim === null || claim === void 0 ? void 0 : claim.impactCatalogItem.title.toLowerCase(),
                            }) }, t('impact-claims.criteria')),
                        React.createElement(CheckList, { items: (claim === null || claim === void 0 ? void 0 : claim.impactCatalogItem.acceptanceCriteria.map(({ description }) => description)) || [] })),
                    React.createElement(SectionContainer, null,
                        React.createElement(SubTitle, { tooltip: t('impact-claims.criteria-document-info', {
                                impactTitle: claim === null || claim === void 0 ? void 0 : claim.impactCatalogItem.title.toLowerCase(),
                            }) }, t('impact-claims.documentCriteria')),
                        React.createElement(CheckList, { items: (claim === null || claim === void 0 ? void 0 : claim.impactCatalogItem.docRequirements.map(({ description }) => description)) || [] }))))))));
};
export default SelectedImpactClaimBlock;
